import { useEffect, useState } from 'react';
import { canvasHitColorsReliable, isCanvasFarblingActive } from '../lib/canvasHitProbe';

/**
 * Shown when privacy tools corrupt canvas pixel reads enough to break selection.
 * Konva 10+ usually works under Brave farbling; this is the fallback UX.
 */
export function CanvasPrivacyBanner() {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Defer so first paint isn't blocked; re-check once after a tick (some
    // extensions patch getImageData lazily).
    const run = () => {
      const farbling = isCanvasFarblingActive();
      const ok = canvasHitColorsReliable();
      setShow(farbling && !ok);
    };
    const t = window.setTimeout(run, 50);
    return () => window.clearTimeout(t);
  }, []);

  if (!show || dismissed) return null;

  return (
    <div className="ox-privacy-banner" role="status">
      <div className="ox-privacy-banner-body">
        <strong>No se puede seleccionar en el lienzo</strong>
        <p>
          Un bloqueador o protección anti-huella (p. ej. Brave Shields) está alterando el canvas.
          Desactiva la protección de huellas / escudos <em>solo para este sitio</em> y recarga.
        </p>
      </div>
      <button type="button" className="ox-privacy-banner-dismiss" onClick={() => setDismissed(true)}>
        Entendido
      </button>
    </div>
  );
}
